import React, {useState} from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import "./App.css";
import "./styles/layout.css";

import Site from "./pages/Site";
import MobileApp from "./pages/MobileApp";
import LeadModal, {ModalType} from "./components/modal/LeadModal";

import {Header} from "./components/navigation/Header";
import {MobileMenu} from "./components/navigation/MobileMenu";
import Calculator from "./pages/Calculator";
import NewsPage from "./pages/NewsPage";
import SchedulePage from "./pages/SchedulePage";
import ProfilePage from "./pages/ProfilePage";
import CurrentOrders from "./pages/CurrentOrders";
import OrdersHistoryPage from "./pages/OrdersHistoryPage";
import RegistrationPage from "./pages/RegistrationPage";
import LoginPage from "./pages/LoginPage";
import AuthRoute from "./components/routes/AuthRoute";
import NotAuthRoute from "./components/routes/NotAuthRoute";
import {NewsItemPage} from "./pages/NewsItemPage";
import RecoverPasswordPage from "./pages/RecoverPassword";
import AdminDirectionsPage from "./admin/pages/AdminDirectionsPage";
import AdminRoute from "./components/routes/AdminRoute";
import AdminViewOrders from "./admin/pages/AdminViewOrders";
import AdminSuppliesPage from "./admin/pages/AdminSuppliesPage";
import ServiceUsersAdminPage from "./admin/pages/ServiceUsersAdminPage";
import NotificationsAdminPage from "./admin/pages/NotificationsAdminPage";
import NewsAdminPage from "./admin/pages/NewsAdminPage";
import DiscountAdminPage from "./admin/pages/DiscountAdminPage";
import AdminDocuments from "./admin/pages/AdminDocuments";
import AdminChangeOrderPage from "./admin/pages/AdminChangeOrderPage";
import AdminOrdersPage from "./admin/pages/AdminOrdersPage";
import AdminHomePage from "./admin/pages/AdminHomePage";
import ErrorPage from "./pages/ErrorPage";
import PaymentPage from "./pages/PaymentPage";

const App: React.FC = () => {
    const [modalType, setModalType] = useState<ModalType>(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const openModal = (type: ModalType) => {
        setModalType(type);
        setIsMobileMenuOpen(false);
    };

    const closeModal = () => setModalType(null);

    return (
        <BrowserRouter>
            <div className="site-root">
                <Header
                    onOpenModal={openModal}
                    onOpenMobileMenu={() => setIsMobileMenuOpen(true)}
                />

                <main className="site-main">
                    <Routes>
                        <Route path="/" element={<NotAuthRoute element={<Site onOpenModal={openModal}/>}/>}/>
                        <Route path="/app" element={<NotAuthRoute element={<MobileApp onOpenModal={openModal}/>}/>}/>
                        <Route path="/site" element={<NotAuthRoute element={<Site onOpenModal={openModal}/>}/>}/>

                        {/* сюда потом добавишь реальные страницы */}
                        <Route path="/calculator" element={<NotAuthRoute element={<Calculator/>}/>}/>
                        <Route path="/news" element={<NotAuthRoute element={<NewsPage/>}/>}/>
                        <Route path="/news/:id" element={<NotAuthRoute element={<NewsItemPage/>}/>}/>
                        <Route path="/schedule" element={<NotAuthRoute element={<SchedulePage/>}/>}/>
                        <Route path="/login" element={<NotAuthRoute element={<LoginPage/>}/>}/>
                        <Route path="/registration" element={<NotAuthRoute element={<RegistrationPage/>}/>}/>
                        <Route path="/recover-password" element={<NotAuthRoute element={<RecoverPasswordPage/>}/>}/>

                        <Route path="/personal-account" element={<AuthRoute element={<ProfilePage/>}/>}/>
                        <Route path="/orders/current" element={<AuthRoute element={<CurrentOrders/>}/>}/>
                        <Route path="/orders/history" element={<AuthRoute element={<OrdersHistoryPage/>}/>}/>
                        <Route path="/payment/:id" element={<AuthRoute element={<PaymentPage/>}/>}/>

                        <Route path="/admin" element={<AdminRoute element={<AdminHomePage/>}
                                                                  requiredRoles={["ROLE_ADMIN"]}/>}/>
                        <Route path="/admin/orders" element={<AdminRoute element={<AdminOrdersPage/>}
                                                                         requiredRoles={["ROLE_ADMIN_ORDERS"]}/>}/>
                        <Route path="/admin/orders/:id" element={<AdminRoute element={<AdminChangeOrderPage/>}
                                                                             requiredRoles={["ROLE_ADMIN_ORDERS"]}/>}/>
                        <Route path="/admin/discount" element={<AdminRoute element={<DiscountAdminPage/>}
                                                                           requiredRoles={["ROLE_ADMIN_DISCOUNT"]}/>}/>
                        <Route path="/admin/documents" element={<AdminRoute element={<AdminDocuments/>}
                                                                            requiredRoles={["ROLE_ADMIN_DOCS"]}/>}/>
                        <Route path="/admin/news" element={<AdminRoute element={<NewsAdminPage/>}
                                                                       requiredRoles={["ROLE_ADMIN_NEWS"]}/>}/>
                        <Route path="/admin/notifications" element={<AdminRoute element={<NotificationsAdminPage/>}
                                                                                requiredRoles={["ROLE_ADMIN_NOTIFICATIONS"]}/>}/>
                        <Route path="/admin/workers" element={<AdminRoute element={<ServiceUsersAdminPage/>}
                                                                          requiredRoles={["ROLE_ADMIN_WORKERS"]}/>}/>
                        <Route path="/admin/supplies" element={<AdminRoute element={<AdminSuppliesPage/>}
                                                                           requiredRoles={["ROLE_ADMIN_SUPPLIES"]}/>}/>
                        <Route path="/admin/orders/view" element={<AdminRoute element={<AdminViewOrders/>}
                                                                              requiredRoles={["ROLE_VIEW_ORDERS"]}/>}/>
                        <Route path="/admin/directions" element={<AdminRoute element={<AdminDirectionsPage/>}
                                                                             requiredRoles={["ROLE_ADMIN_DIRECTIONS"]}/>}/>

                        <Route path="/403" element={<ErrorPage code={403} title="Доступ запрещён"/>}/>
                        <Route path="*" element={<ErrorPage code={404} title="Страница не найдена"/>}/>
                    </Routes>
                </main>

                <footer className="site-footer">
                    <p>© {new Date().getFullYear()} FulfilWeb</p>
                    <p>Все права защищены.</p>
                </footer>

                <LeadModal type={modalType} onClose={closeModal}/>

                <MobileMenu
                    isOpen={isMobileMenuOpen}
                    onClose={() => setIsMobileMenuOpen(false)}
                    onOpenModal={openModal}
                />
            </div>
        </BrowserRouter>
    );
};

export default App;
